import { useAppStore } from '@/store/store';
import { FreightModeSelector } from '@/components/Calculator/FreightModeSelector';
import { DimDivisorInput } from '@/components/Calculator/DimDivisorInput';
import { PackageGrid } from '@/components/Calculator/PackageGrid';
import { TemplatePicker } from '@/components/Calculator/TemplatePicker';
import { SummaryPanel } from '@/components/Calculator/SummaryPanel';
import { ResultBreakdown } from '@/components/Calculator/ResultBreakdown';
import { FormulaBreakdown } from '@/components/Calculator/FormulaBreakdown';
import { CostInputPanel } from '@/components/Calculator/CostInputPanel';
import { ImportButton } from '@/components/Calculator/ImportButton';
import { ExportMenu } from '@/components/Calculator/ExportMenu';
import { ShareButton } from '@/components/shared/ShareButton';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';

interface CalculatorScreenProps {
  onErrorReport?: () => void;
}

export function CalculatorScreen({ onErrorReport }: CalculatorScreenProps) {
  const mode = useAppStore((s) => s.mode);

  return (
    <div className="calculator-layout">
      <ErrorBoundary onReportError={onErrorReport}>
        <div className="calculator-input-column">
          <section aria-label="Freight mode selection">
            <FreightModeSelector />
          </section>

          <section aria-label="Dimensional divisor" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 'var(--space-2)', alignItems: 'center' }}>
            <DimDivisorInput />
            <TemplatePicker />
          </section>

          <section aria-label="Import and export" style={{ display: 'flex', gap: 'var(--space-2)', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <ImportButton />
            <ExportMenu />
            <ShareButton />
          </section>

          <section aria-label="Package dimensions">
            <PackageGrid />
          </section>

          <section aria-label="Cost input">
            <CostInputPanel mode={mode} />
          </section>
        </div>
      </ErrorBoundary>

      <ErrorBoundary onReportError={onErrorReport}>
        <div className="calculator-results-column">
          <section aria-label="Shipment summary">
            <SummaryPanel />
          </section>

          <section aria-label="Calculation breakdown">
            <ResultBreakdown />
            <FormulaBreakdown />
          </section>
        </div>
      </ErrorBoundary>
    </div>
  );
}
